'use strict';

angular.module('businessPlanModule', []);
